import { render, staticRenderFns } from "./TakeCoin.vue?vue&type=template&id=d1dc0436&"
import script from "./TakeCoin.vue?vue&type=script&lang=js&"
export * from "./TakeCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports